"use client";
// react imports
import { useEffect } from "react";
// next imports
import { Inter } from "next/font/google";
import { useRouter } from "next/navigation";
// components imports
import { LayoutBody } from "@/components";
import { ChunkLoadErrorGlobalHandler } from "@/components/ChunkLoadErrorSplash";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "@/utils/ErrorBoundary";
// context imports
import { ThemeProvider } from "@/context";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { muiTheme } from "@/theme/muiTheme";
import { GlobalStateProvider } from "@/context/GlobalContext";
import { LanguageStateProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { PreviousStateProvider } from "@/context/PreviousStateContext";

const inter = Inter({ subsets: ["latin"] });

export default function RootLayout({
  children
}: Readonly<{
  children: React.ReactNode;
}>) {
  const router = useRouter();

  useEffect(() => {
    // You can perform other client-side checks here if needed
  }, [router]);

  return (
    <html lang="en">
      <head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </head>
      <body className={inter.className}>
        <AuthProvider>
          <MuiThemeProvider theme={muiTheme}>
            <ThemeProvider>
              <GlobalStateProvider>
                <LanguageStateProvider>
                  <PreviousStateProvider>
                    <ChunkLoadErrorGlobalHandler />
                    <LayoutBody>
                      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
                    </LayoutBody>
                  </PreviousStateProvider>
                </LanguageStateProvider>
              </GlobalStateProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </AuthProvider>
      </body>
    </html>
  );
}
